import React from 'react'

import './generic-modal.scss'

export default function GenericModal({
  children,
  blur = false,
  isUpdateData = false,
  fondoPregame = false,
  className = '',
}) {
  return (
    <div
      className={`generic-modal ${blur ? 'blur' : ''} ${
        isUpdateData ? 'purpple' : ''
      } ${fondoPregame ? 'fondoPregame' : ''} 
      ${className}`}
    >
      <div className="generic-modal__body">{children}</div>
    </div>
  )
}
